"use client";
import { Section } from "../ui/section";
import { useTranslation } from "@/lib/i18n";
import {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
} from "../ui/accordion";

const faqs = (t: any) => [
    {
        question: t("faq.q1"),
        answer: t("faq.a1"),
    },
    {
        question: t("faq.q2"),
        answer: t("faq.a2"),
    },
    {
        question: t("faq.q3"),
        answer: t("faq.a3"),
    },
    {
        question: t("faq.q4"),
        answer: t("faq.a4"),
    },
    {
        question: t("faq.q5"),
        answer: t("faq.a5"),
    },
];

export default function FAQ() {
  const { t } = useTranslation("common");
    return (
        <Section>
            <div className="mx-auto flex max-w-container flex-col items-center gap-8">
                <h2 className="text-center text-3xl font-semibold sm:text-5xl">
                    {t("faq.title")}
                </h2>
                <Accordion
                    type="single"
                    collapsible
                    className="w-full max-w-[800px]"
                >
                    {faqs(t).map((faq: any, index: number) => (
                        <AccordionItem key={index} value={`item-${index + 1}`}>
                            <AccordionTrigger>{faq.question}</AccordionTrigger>
                            <AccordionContent>
                                <p className="mb-4 max-w-[640px] text-balance text-muted-foreground">
                                    {faq.answer}
                                </p>
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </Section>
    );
}
